import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Fade,
  Paper,
  Divider
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import LoadingImage from '../../components/LoadingImage';

const FrigoDorseKasaTamiriV4: React.FC = () => {
  useEffect(() => {
    document.title = "Dorse Kapı Tamiri ve Kasa Sızdırmazlık İşlemleri - Kale Treyler";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', "Mersin MIG tır parkı bölgesinde sunulan dorse kapı tamiri ve kasa paneli revizyon hizmetleri.");
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', "dorse kasa polyester yama, poliüretan panel dolgusu, soğutmalı dorse panel onarımı, tır dorse kasa boyama");
    }

    const canonicalLink = (document.querySelector('link[rel="canonical"]') || document.createElement('link')) as HTMLLinkElement;
    canonicalLink.setAttribute('rel', 'canonical');
    canonicalLink.setAttribute('href', 'https://kaletreyler.com/blog/frigo-dorse-kasa-tamiri-mersin-4');
    if (!document.head.contains(canonicalLink)) {
      document.head.appendChild(canonicalLink);
    }
  }, []);

  return (
    <Box sx={{ bgcolor: 'grey.50', py: 8 }}>
      <Container maxWidth="lg">
        <Fade in timeout={800}>
          <Box>
            <Button
              component={RouterLink}
              to="/blog"
              startIcon={<ArrowBack />}
              sx={{ mb: 4, textTransform: 'none', fontWeight: 'bold' }}
            >
              Blog Yazılarına Dön
            </Button>

            <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, border: '1px solid', borderColor: 'grey.200', borderRadius: 4 }}>
              <Typography variant="overline" color="secondary" sx={{ fontWeight: 'bold', letterSpacing: 1.5 }}>
                Kasa Tamiri
              </Typography>
              <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 800, mt: 1, mb: 4, fontSize: { xs: '2rem', md: '3rem' }, lineHeight: 1.2 }}>
                Dorse Kapı Tamiri ve Kasa Sızdırmazlık İşlemleri
              </Typography>

              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 4 }}>
                <Typography variant="body2" color="text.secondary">
                  Yayınlanma Tarihi: <strong>12 Temmuz 2026</strong>
                </Typography>
                <Divider orientation="vertical" flexItem />
                <Typography variant="body2" color="text.secondary">
                  Yazar: <strong>Kale Treyler Editör</strong>
                </Typography>
              </Box>

              <Box sx={{ borderRadius: 3, overflow: 'hidden', mb: 6, boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
                <LoadingImage
                  src="/1.jpg"
                  alt="Dorse Kapı Tamiri ve Kasa Sızdırmazlık İşlemleri"
                  style={{ width: '100%', height: 'auto', maxHeight: '500px', objectFit: 'cover' }}
                />
              </Box>

              <Box sx={{ typography: 'body1', color: 'text.primary', lineHeight: 1.8 }}>
                
<Typography variant="body1" paragraph sx={{ mb: 3 }}>MIG tır parkı dorse onarım alanımızda, hasarlı dorse kapılarını menteşelerinden sökerek çerçeve doğrultma, kilit ayarı ve sızdırmazlık fitili değişim işlemlerini yapıyoruz.</Typography>
<Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mt: 4, mb: 2, color: 'primary.main' }}>Sektörel İnceleme ve Teknik Çözümler</Typography>
<Typography variant="body1" paragraph sx={{ mb: 3 }}>Lokal panel onarımında, delinen alan kesilerek açılır ve nemli poliüretan dolgu temizlenir. Kurutulan boşluğa yüksek yoğunluklu yeni sıvı poliüretan enjekte edilir.</Typography>
<Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mt: 4, mb: 2, color: 'primary.main' }}>Uygulama ve Bakım Aşamaları</Typography>
<Typography variant="body1" paragraph sx={{ mb: 3 }}>Kaza veya çarpmalar sonucu soğutmalı tır kasalarında ezikler ve yırtıklar oluşabilir. Sac kaplamanın zarar görmesi, kasanın yalıtımlı gövdesine nem sızmasına yol açar.</Typography>
<Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mt: 4, mb: 2, color: 'primary.main' }}>Verimlilik ve İşletme Analizi</Typography>
<Typography variant="body1" paragraph sx={{ mb: 3 }}>Zamanında yapılan lokal panel tamirleri, tüm kasanın yalıtım özelliğini yitirmesini önler ve büyük çaplı dorse kasa değişim maliyetlerinin önüne geçer.</Typography>
                
                <Typography variant="body1" paragraph sx={{ mt: 4 }}>
                  Mersin Akdeniz bölgesinde ve MIG tır parkı civarında dorse tamir ve bakımı arayan tır filoları ve nakliye profesyonellerine, <RouterLink to="/" style={{ color: '#1e3a8a', fontWeight: 'bold', textDecoration: 'underline' }}>Kale Treyler Frigo</RouterLink> bünyesinde uzman ekibimizle hizmet vermekten memnuniyet duyarız.
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', borderLeft: '4px solid', borderColor: 'primary.main', pl: 2, py: 1, mt: 4, bgcolor: 'grey.100' }}>
                  Not: Sitemizde yer alan tüm blog içerikleri lojistik sektörü çalışanları için genel bilgilendirme amacıyla hazırlanmıştır. Aracınızın marka ve modeline en uygun özel çözümler için lütfen teknik ekibimizle iletişime geçiniz.
                </Typography>
              </Box>
            </Paper>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default FrigoDorseKasaTamiriV4;